<template>
  <UniversalSelect
      v-model="localModel"
      :mode="mode"
      :searchable="searchable"
      :options="options"
      :disabled="isLoading"
      :loading="isLoading"
      :label="label"
      placeholder="Не выбрано"
      :default-image="defaultImage"
      @onChange="emit('change', $event)"
  />
</template>

<script setup>
import { onMounted, computed, defineOptions } from "vue"
import UniversalSelect from "@/components/select_universal/Index"
import { useThemes } from "./useThemes"

defineOptions({
  name: "WishlistThemes"
})

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => []
  },
  mode: {
    type: String,
    default: "tags"
  },
  searchable: {
    type: Boolean,
    default: true
  },
  defaultImage: {
    type: String,
    default: "/assets/static/user/no_image.jpg"
  },
  label: {
    type: String,
    default: "Тема"
  },
})

const emit = defineEmits(['update:modelValue', 'change'])

const localModel = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const { options, isLoading, fetchThemes } = useThemes()

onMounted(async () => {
  await fetchThemes()
})
</script>
